import PropTypes from "prop-types";
import reniImg from "../assets/Reni.webp";

/**
 * ReniLoader — Pantalla de carga con la mascota Reni (abeja ARS Renacer).
 *
 * Muestra un overlay a pantalla completa con animación de vuelo realista:
 *   • Trayectoria sinusoidal (arriba/abajo con deriva lateral)
 *   • Aleteo rápido que simula las alas de la abeja
 *   • Sombra en el suelo que crece/encoge inversamente al vuelo
 *   • Puntos de carga animados escalonados
 *
 * Props:
 *   text — texto que aparece bajo la abeja (default "Cargando")
 */
const ReniLoader = ({ text = "Cargando" }) => (
  <div
    className="reni-overlay"
    role="status"
    aria-label="Cargando contenido"
    aria-live="polite"
  >
    <img src={reniImg} alt="Reni la abeja" className="reni-bee" />
    <div className="reni-shadow-el" aria-hidden="true" />

    <p className="reni-label">
      {text}
      <span className="reni-dots" aria-hidden="true">
        <span /><span /><span />
      </span>
    </p>
  </div>
);

ReniLoader.propTypes = {
  text: PropTypes.string,
};

export default ReniLoader;
